<template>
    <div class="video-tutorial">
      <Layout ref="layoutRef" :selectedOption="4" />
      <div class="tutorial-content">
        <div class="video-list">
          <h4>Tutoriales Disponibles</h4>
          <hr>
          <ul>
            <li v-for="(video, index) in videos" :key="index">
              <button @click="selectVideo(video.url)" class="video-button">{{ video.title }}</button>
            </li>
          </ul>
        </div>
        <div class="video-player">
          <video ref="videoPlayer" controls>
            <source :src="currentVideo" type="video/mp4">
            Tu navegador no soporta la etiqueta video.
          </video>
        </div>
      </div>
      <Footer />
    </div>
  </template>
  
  
  <script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'

  export default {
    name: 'VideoTutorials',
    components : {
        Layout, Footer
    },
    data() {
      return {
        videos: [
          { title: 'Tutorial 1', url: 'path/to/video1.mp4' },
          { title: 'Tutorial 2', url: 'path/to/video2.mp4' },
          { title: 'Tutorial 3', url: 'path/to/video3.mp4' }
        ],
        currentVideo: ''
      }
    },
    mounted () {
      this.$refs.layoutRef.toggleProcesos()
      this.$refs.layoutRef.toggleReportes()
      this.$refs.layoutRef.toggleParametros()
      this.$refs.layoutRef.toggleAyuda()
    },
    methods: {
      selectVideo(videoUrl) {
        this.currentVideo = videoUrl;
        this.$refs.videoPlayer.load();
      }
    }
  }
  </script>
  
  <style scoped>
  .video-tutorial {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1200px;
    margin: auto;
    padding: 20px;
  }
  
  .tutorial-content {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin-top: 20px;
  }
  
  .video-list {
    width: 30%;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    padding: 20px;
    border-radius: 8px;
    background-color: #f8f9fa;
  }
  
  .video-list h4 {
    margin-top: 0;
  }
  
  .video-list ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .video-button {
    display: block;
    width: 100%;
    background-color: transparent;
    border: 2px solid #007BFF;
    color: #007BFF;
    padding: 10px 15px;
    margin-bottom: 10px;
    border-radius: 5px;
    transition: background-color 0.3s, color 0.3s;
    text-align: left;
  }
  
  .video-button:hover, .video-button:focus {
    background-color: #007BFF;
    color: white;
    text-decoration: none;
    outline: none;
  }
  
  .video-player {
    width: 65%;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-radius: 8px;
  }
  
  .video-player video {
    width: 100%;
    height: auto;
    border-radius: 5px;
  }
  </style>
  